import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';

import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl } from "../../Utils/Common";

const CreatePelanggan = ({ onCallback, show, close }) => {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken, setAccessToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {

    }, [isLoading]);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Field harus diisi'),
        phone: Yup.string().required('Field harus diisi'),
        email: Yup.string().email(),
        address: Yup.string()
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        setLoading(true);

        let formData = new FormData();    //formdata object

        formData.append('name', data.name);
        formData.append('email', data.email);
        formData.append('phone', data.phone);
        formData.append('address', data.address);
        formData.append('user_id', userLogin.id);

        fetch(getEndpointUrl() + '/customer', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Data pelanggan berhasil diinput.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                close();

                onCallback(json.results.data);

            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menyimpan data..." : "Input data pelanggan"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Nama pelanggan</Form.Label>
                                    <Form.Control type="text" {...register("name")} isInvalid={errors.name ? true : false} autoComplete="off" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>No Handphone</Form.Label>
                                    <Form.Control type="text" {...register("phone")} isInvalid={errors.phone ? true : false} autoComplete="off" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Alamat E-mail</Form.Label>
                                    <Form.Control type="text" {...register("email")} isInvalid={errors.email ? true : false} autoComplete="off" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Alamat</Form.Label>
                                    <Form.Control type="text" as={'textarea'} {...register("address")} isInvalid={errors.address ? true : false} autoComplete="off" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="success" type="submit">Input data pelanggan</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(CreatePelanggan);
